import React, { FC, ReactNode } from 'react';
import { Button } from '../Button';
import { Heading } from '../Heading';
import { Icon, IconName } from '../Icon';

export interface ModalProps {
  cancelText: string;
  children?: React.ReactNode;
  confirmText: string;
  footer?: ReactNode;
  heading: string;
  icon?: IconName;
  isCancelHidden?: boolean;
  isComplex?: boolean;
  isConfirmButtonDisabled?: boolean;
  isHidden: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
}
export const Modal: FC<ModalProps> = ({
  cancelText,
  children,
  confirmText,
  footer,
  heading,
  icon,
  isCancelHidden,
  isComplex = false,
  isConfirmButtonDisabled,
  isHidden,
  onCancel,
  onConfirm,
}) => {
  return (
    <div
      className={`${isHidden ? 'hidden' : ''} ${
        isComplex ? 'sm:p-4' : 'p-3'
      } md:p-8 fixed inset-0 overflow-auto flex backdrop-blur-lg z-50 bg-gray-700t`}
      data-testid='modal-outer'
    >
      <div
        className={`${
          isComplex
            ? 'w-full sm:max-w-[550px] min-h-full sm:min-h-0 sm:rounded'
            : 'max-w-[550px] rounded'
        } bg-white shadow-12dp relative flex flex-col m-auto`}
      >
        {!isCancelHidden && (
          <button
            className="absolute top-0 right-0 self-end w-4 h-4 mt-6 mr-6 text-gray-600 hover:text-blue-100 focus:text-blue-100"
            onClick={onCancel}
          >
            <Icon name="Close" />
          </button>
        )}
        <div
          className={`${
            // need the xs:pt-7 class because it would be overwritten by xs:p-5
            !isCancelHidden ? 'pt-12 xs:pt-7' : ''
          } max-w-full flex flex-col items-center p-8 xs:p-10 md:p-12 m-auto`}
        >
          {icon && (
            <div className="mb-6 w-12 text-gray-700">
              <Icon name={icon} />
            </div>
          )}
          <div className="max-w-full mb-10 text-center md:mb-12">
            <Heading level="h2" text={heading} align="center" weight='bold' />
            {children && <div className='font-regular mt-2'>{children}</div>}
          </div>
          <div className="flex flex-col space-y-3">
            <Button
              label={confirmText}
              onClick={onConfirm}
              disabled={isConfirmButtonDisabled}
            />

            {!isCancelHidden && (
              <Button label={cancelText} onClick={onCancel} variant="white" />
            )}
          </div>
        </div>
        {footer && (
          <div className="px-3 py-2 -mt-1 text-center xs:px-5 md:px-7 xs:py-3 md:py-5 xs:-mt-2 md:-mt-3 bg-gray-100">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};
